import { render, staticRenderFns } from "./StudentsTableSample.vue?vue&type=template&id=0ed95d86&"
import script from "./StudentsTableSample.vue?vue&type=script&lang=js&"
export * from "./StudentsTableSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports